var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEdit = function SvgEdit(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5928 9.042L15.0118 6.439L17.4808 4.019L19.9778 6.538C19.9838 6.544 19.9728 6.64 19.9798 6.646L17.5928 9.042ZM6.5898 20H3.9998V17.379L13.5848 7.841L16.1798 10.458L6.5898 20ZM21.9998 6.557C21.9928 6.001 21.7718 5.487 21.3978 5.13L18.9188 2.63C18.5498 2.236 18.0238 2.007 17.4738 2H17.4468C16.8958 2 16.3618 2.222 15.9788 2.607L2.2948 16.254C2.1068 16.441 1.9998 16.697 1.9998 16.963V21C1.9998 21.553 2.4468 22 2.9998 22H7.0028C7.2678 22 7.5208 21.896 7.7078 21.709L21.3978 8.057C21.7878 7.663 22.0078 7.116 21.9998 6.557Z"
  })));
};
export default SvgEdit;